import { render, staticRenderFns } from "./couture.vue?vue&type=template&id=225c8c27&"
import script from "./couture.vue?vue&type=script&lang=js&"
export * from "./couture.vue?vue&type=script&lang=js&"
import style0 from "./couture.vue?vue&type=style&index=0&lang=css&"
import style1 from "./couture.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports